import { MOBILE_HEADER_HEIGHT, MOBILE_HEADER_POPOVER_HEIGHT, SUGGEST_ITEM_HEIGHT } from './constants';

var defaultFilter = function defaultFilter(find) {
  return function (val) {
    var label = val.label.replace(/ё/g, 'е').toLowerCase();
    return label.indexOf(find) !== -1;
  };
};

export var filterOptions = function filterOptions(_ref) {
  var val = _ref.val,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? defaultFilter : _ref$filter;
  var value = val.trim().toLowerCase().replace(/ё/g, 'е');
  return !value.length ? [] : options.filter(filter(value));
};
export var getCallId = function getCallId() {
  return Symbol('suggestId');
};
export var getScrollbarProps = function getScrollbarProps(_ref2) {
  var isMobile = _ref2.isMobile,
      height = _ref2.height,
      mobilePopover = _ref2.mobilePopover,
      visibleSuggestionsCount = _ref2.visibleSuggestionsCount;

  if (!isMobile && visibleSuggestionsCount) {
    return {
      maxHeight: SUGGEST_ITEM_HEIGHT * visibleSuggestionsCount
    };
  }

  var headerHeight = mobilePopover ? MOBILE_HEADER_POPOVER_HEIGHT : MOBILE_HEADER_HEIGHT;
  return {
    maxHeight: height - headerHeight
  };
};